import { create } from "zustand/index";
export var useErrorFeedbackStore = create(function (set) { return ({
    open: false,
    setOpen: function (value) { return set({ open: value }); },
    setDescription: function (description) { return set({ description: description }); },
    showError: function (description) { return set({ description: description, open: true }); },
}); });
